import { defaultTheme } from "react-admin";
import merge from "lodash/merge";
import { createTheme } from "@mui/material/styles";
import logo from "./static/logo.png";

const fdPalette = merge({}, defaultTheme.palette, {
  primary: {
    main: "#7BB225", // fd-green
    light: "#C5DE9F", // fd-green-light
    dark: "#1A7C65", // fd-dark-green
  },
  common: {
    black: "#242424" /* fd-copy-dark */,
  },
  text: {
    primary: "#787878", // fd-grey
  },
  grey: {
    500: "#EEEEEE",
    600: "#F5F5F5" /* fd-grey-ultralight */,
    700: "#E7E7E7" /* fd-grey-light */,
    800: "#A8A8A8",
  },
  warning: {
    main: "#F6A316", // fd-orange
  },
  error: {
    main: "#F64D16", // fg-red
  },
});

const fdTypography = {
  fontFamily: ["Poppins"].join(","),
  fontSize: 14,
  h1: {
    fontSize: "32px",
    color: "#333333",
    fontWeight: "bold",
  },
  h2: {
    fontWeight: "bold",
    fontSize: "22px",
    color: "#242424",
  },
  h3: {
    fontWeight: "bold",
    fontSize: "26px",
    color: "#333333",
  },
  body1: {
    fontSize: "14px",
    color: "#787878",
  },
  body2: {
    fontSize: "12px",
  },
};

const fdTheme = {
  palette: fdPalette,
  typography: fdTypography,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          letterSpacing: "0",
          textTransform: 'initial',
        },
        contained: {
          borderRadius: "200px",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "16px",
          letterSpacing: 0.5,
          boxShadow:
          "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
          "&:hover": {
            boxShadow: "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
          },
        },
        text: {
          // color: fdPalette.text.primary,
          padding: 0,
          "&:hover": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          height: "60px",
          fontSize: fdTypography.fontSize,
          boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.05)",
        },
        colorSecondary: {
          backgroundColor: "#fff",
          color: fdPalette.text.primary,
        },
      },
    },
    RaAppBar: {
      styleOverrides: {
        toolbar: {
          minHeight: "60px",
          paddingLeft: "24px",
        },
        menuButton: {
          display: "none",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          height: "calc(100vh - 60px)",
          width: "250px",
          backgroundColor: "#FFF",
          boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.05)",
          backgroundImage: `url(${logo})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center bottom 50px",
        },
      },
    },
    RaSidebar: {
      styleOverrides: {
        root: {
          position: "fixed",
          top: "60px",
          zIndex: 1,
          '&.RaSidebar-appBarCollapsed':{
            marginTop: "0px",
          },
          drawerPaper: {
            // height: "calc(100vh - 60px)",
            // width: "250px",
            // backgroundColor: "#FFF",
            // boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.05)",
            // backgroundImage: `url(${logo})`,
            // backgroundRepeat: "no-repeat",
            // backgroundPosition: "center bottom 50px",
          },
        },
      },
    },
    RaLoading: {
      styleOverrides: {
        container: {
          height: "500px !important",
        },
      },
    },
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          borderLeft: "4px solid #fff",
          color: "#A8A8A8",
        },
      },
      active: {
        borderLeft: "4px solid #7BB225 !important",
        color: "#242424 !important",
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          paddingTop: "12px",
          paddingBottom: "12px",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          marginTop: "20px",
          marginBottom: "20px",
        },
      },
    },
    MuiTextField: {
      defaultProps:{
        variant:'outlined',
      },
      styleOverrides: {
        root: {
          width: "100%",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          border: "1px solid #E7E7E7",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.05)",
          borderRadius: "6px !important",
          background: "#fff",
          padding: "12px 10px",
          input:{
            padding:0,
          },


          inputMultiline: {
            height: "auto !important",
            paddingTop: "6px",
            paddingBottom: "7px",
          },
          // "& .MuiInputBase-input": {
          //   "&.MuiInputBase-adornedEnd": {
          //     padding: "12px 30px 12px 10px",
          //   },
          // },
          "& .MuiOutlinedInput-notchedOutline": {
            display: "none !important",
          },
          '& .MuiSelect-select':{
            paddingBottom:0,
            paddingTop:0,
            paddingLeft:0,
            lineHeight:'initial',
            '&:focus':{
              backgroundColor:'transparent',
            }
          },
        },
      },
    },
    MuiSelect: {
      defaultProps:{
        variant:'outlined',
      },
      styleOverrides: {
        icon: {
          right: "7px",
        },
      },
    },

    // MuiBadge: {
    //   styleOverrides: {
    //     badge: {
    //       background: "none",
    //     },
    //   },
    // },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "16px",
          "&.MuiInputLabel-shrink": {
            transform: "translate(0, 3.5px) scale(0.75)",
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          // fontSize: "2em",
          color: "#000",
          backgroundColor: "#F5F5F5",
          border: "1px solid #E7E7E7",
        },
      },
    },
    //@ts-ignore
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& input": {
            border: "0 !important",
            boxShadow: "none !important",
          },
          "&.MuiAutocomplete-inputRoot": {
            border: "1px solid #E7E7E7",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.05)",
            borderRadius: "6px !important",
            padding: "12px 10px",
            background: "#fff",
          },
        },
        inputRoot: {
          '&&[class*="MuiInput-root"]': {
            paddingRight: "0 !important",
          },
          "&.MuiInputBase-root,&.MuiFilledInput-root": {
            border: "1px solid #E7E7E7",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.05)",
            borderRadius: "6px !important",
            padding: "0",
            background: "#fff",
            flex: 1,
            "&.MuiInputBase-sizeSmall": {
              "& input": {
                padding: "12px 10px",
              },
            },
            "& input": {
              border: 0,
              boxShadow: "none",
              padding: "12px 10px",
              margin: 0,
            },
          },
        },
        endAdornment: { right: "7px" },
        "& .MuiInputBase-root": {
          border: "1px solid #E7E7E7",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.05)",
          borderRadius: "6px !important",
          padding: "12px 10px",
          background: "#fff",
          flex: 1,
        },

        "& input": {
          border: 0,
          boxShadow: "none",
          padding: "0 !important",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          color: "inherit",
        },
        colorPrimary: {
          color: "#fff",
          backgroundColor: fdPalette.primary.dark,
        },
        deleteIconColorPrimary: {
          color: "#fff",

          "&:hover": {
            color: "#fff",
          },
        },
      },
    },
    MuiInputLabel: {
     defaultProps:{
      shrink:'true',
     },
      styleOverrides: {
        formControl: {
          position: "relative",
          textAlign: "left",
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        formControl: {
          marginTop: "0 !important",
        },
        underline: {
          "&:before": {
            border: "0 !important",
          },
        },
      },
    },

    MuiAvatar: {
      styleOverrides: {
        root: {
          width: "42px",
          height: "42px",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: fdPalette.text.primary,
        },
      },
    },
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        width: "42px",
        height: "42px",
      },
    },
  },
  MuiFilledInput: {
    styleOverrides: {
      root: {
        backgroundColor: "transparent",
      },
    },
  },
  MuiButtonBase: {
    styleOverrides: {
      root: {
        "&.MuiPickersDay-root": {
          backgroundColor: fdPalette.primary.main,
        },
      },
    },
  },
  MuiInputLabel: {
    defaultProps: { shrink: false },
  },
};

export const theme = createTheme(merge({}, defaultTheme, fdTheme));